"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackBulkUnmuteModal = void 0;
var _react = require("react");
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _DialogContent = require("../../primitives/DialogContent");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TrackBulkUnmuteModal = function TrackBulkUnmuteModal() {
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    muteNotification = _useState2[0],
    setMuteNotification = _useState2[1];
  var notification = (0, _reactSdk.useHMSNotifications)(_reactSdk.HMSNotificationTypes.CHANGE_MULTI_TRACK_STATE_REQUEST);
  (0, _react.useEffect)(function () {
    if (notification !== null && notification !== void 0 && notification.data.enabled) {
      setMuteNotification(notification.data);
    }
  }, [notification]);
  if (!muteNotification) {
    return null;
  }
  var peer = muteNotification.requestedBy,
    tracks = muteNotification.tracks,
    enabled = muteNotification.enabled;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.RequestDialog, {
    title: "Track Unmute Request",
    body: "".concat(peer === null || peer === void 0 ? void 0 : peer.name, " has requested you to unmute your tracks."),
    onOpenChange: function onOpenChange(value) {
      return !value && setMuteNotification(null);
    },
    onAction: function onAction() {
      tracks.forEach(function (track) {
        hmsActions.setEnabledTrack(track.id, enabled);
      });
      setMuteNotification(null);
    },
    Icon: _reactIcons.MicOnIcon
  });
};
exports.TrackBulkUnmuteModal = TrackBulkUnmuteModal;